import { exportDataGrid } from 'devextreme/excel_exporter';

export const exportExcel = async(fileName:string, dataGridInstance: any ) => {
  const { Workbook } = await import('exceljs');
  const { default: saveAs } = await import('file-saver');
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet(fileName);
  exportDataGrid({ component: dataGridInstance, worksheet })
    .then(() => {
      worksheet.columns.forEach(c => { c.width = Math.min(50, c?.width ?? 50); });
      workbook.xlsx.writeBuffer()
        .then((buffer) => saveAs(new Blob([ buffer ], { type: 'application/octet-stream' }), `${fileName}.xlsx`))
        .catch((e) => console.log(e));
    })
    .catch((e) => console.log(e));
};
